import { render, staticRenderFns } from "./AKInfoModal.vue?vue&type=template&id=e457ce12&scoped=true&"
import script from "./AKInfoModal.vue?vue&type=script&lang=ts&"
export * from "./AKInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./AKInfoModal.vue?vue&type=style&index=0&id=e457ce12&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e457ce12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VExpansionPanels,VIcon})
